import React from 'react'
import { Typography } from "@material-ui/core"

const DeedTypography = ({ children, ...other }) => {
    return <Typography style={{ fontFamily: "CourierNew,serif", fontSize: "12pt" }} {...other}>
        {children}
    </Typography>
}

export default DeedTypography